import React from 'react';
import { classNames } from '../../../utils/style';
export const TotalPriceSmall = ({
  price,
  prefixTotal,
  currencyFirst,
  currency,
  previousPrice,
  sufixTotal,
}: any) => {
  return (
    <div className="price text-neutral-301 font-semibold">
      {prefixTotal}
      <span>
        {currencyFirst && <span>{currency}</span>}
        {price}
        {!currencyFirst && <span>&nbsp;{currency}</span>}
      </span>
      {previousPrice && (
        <span>
          &nbsp;
          <span className={classNames('line-through text-silver-300')}>
            {currencyFirst && <span>{currency}</span>}
            {previousPrice} {!currencyFirst && <span>{currency}</span>}
          </span>
        </span>
      )}
      <span> {sufixTotal}</span>
    </div>
  );
};
